<ng-container *ngFor="let item of data.items">
	<ng-container *ngIf="layout[item.type]">
		<cv-schema-render-section [item]="item" [layoutNode]="layout[item.type]"></cv-schema-render-section>
	</ng-container>
</ng-container>